<template>
  <div class="flex flex-row">
    <div class="mr-2">{{ departureTime }}</div>
    <div class="mr-2 text-left min-w-[64px]">
      <img loading="lazy" class="inline-block align-middle" :src="lineImgName" :alt="departure.line.name">
    </div>

    <div class="mr-2">{{ departure.line.direction }}</div>
    <div v-if="false" class="mr-2">{{ departure.timeOffset }}</div>
    <div v-if="false" class="mr-2">{{ departure.delay }}</div>
  </div>
  <div class="flex flex-row text-xs">
    <div class="mr-2">{{ originalDepurtureTime }}</div>
    <div class="mr-2">+{{ delayInMinutes }}</div>
  </div>
  <pre v-if="false">
    {{ departure }}
  </pre>
</template>

<script>

export default {
  name: "HvvDepartures",
  components: {
  },
  props: {
    departure: {
      timeOffset: 0,
      delay: 0,
      line: {
        type: {
          simpleType: ""
        },
        name: "",
        direction: ""
      }
    },
    time: Number,
  },
  data() {
    return {}
  },
  computed: {
    lineImgName() {
      return "https://cloud.geofox.de/icon/linename?name=" + this.departure.line.name + "&outlined=true&fileFormat=SVG&height=14&appearance=COLOURED"
    },
    departureTime() {
      let tempDeparture = {
        timeOffset: 0,
        delay: 0,
        ...this.departure
      }
      const departureTimeInt = parseInt(this.time) + tempDeparture.timeOffset + tempDeparture.delay / 60
      const fullHours = departureTimeInt / 60
      const hours = Math.floor(fullHours)
      const minutes = ((fullHours - hours) * 60).toFixed(0)
      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
    originalDepurtureTime() {
      const departureTimeInt = parseInt(this.time) + this.departure.timeOffset
      const fullHours = departureTimeInt / 60
      const hours = Math.floor(fullHours)
      const minutes = ((fullHours - hours) * 60).toFixed(0)
      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
    delayInMinutes() {
      return ((this.departure.delay || 0 ) / 60).toFixed(0)
    },
  },
  created() { },
  methods: {
  },
}
</script>
